import type { ReadonlyRequestCookies } from '../@types/global'

import {
  SESSION_COOKIE_CHUB_CURRENT_TENANT,
  SESSION_COOKIE_CHUB_SIGNED_TOKEN,
  SESSION_COOKIE_CHUB_USER,
  SESSION_COOKIE_CURRENT_TENANT,
  SESSION_COOKIE_NAME,
  SESSION_COOKIE_NAME_CHUB,
  SESSION_COOKIE_SIGNED_TOKEN,
  SESSION_COOKIE_TENANTS,
  SESSION_COOKIE_USER,
  SESSION_ERROR_MESSAGE
} from '~/core/constants/cookies'
import { AppType } from '~/core/constants/enum'

//-----------------Server------------------//
export function getAuthCookies(cookies: ReadonlyRequestCookies, appType: AppType) {
  const cookiesObject = cookies.getAll().reduce<Record<string, string>>((acc, { name, value }) => {
    acc[name] = value
    return acc
  }, {})
  if (appType === AppType.CHUB_APP) {
    return {
      authCookie: cookiesObject[SESSION_COOKIE_CHUB_USER],
      currentTenantCookie: cookiesObject[SESSION_COOKIE_CHUB_CURRENT_TENANT],
      tenantsCookie: cookiesObject[SESSION_COOKIE_TENANTS], // Shared
      errorMessage: cookiesObject[SESSION_ERROR_MESSAGE]
    }
  }

  return {
    authCookie: cookiesObject[SESSION_COOKIE_USER],
    currentTenantCookie: cookiesObject[SESSION_COOKIE_CURRENT_TENANT],
    tenantsCookie: cookiesObject[SESSION_COOKIE_TENANTS],
    errorMessage: cookiesObject[SESSION_ERROR_MESSAGE]
  }
}

export function getAuthorizationBearerToken(
  cookies: ReadonlyRequestCookies,
  appType: AppType
): string | null {
  const cookiesObject = cookies.getAll().reduce<Record<string, string>>((acc, { name, value }) => {
    acc[name] = value
    return acc
  }, {})
  if (appType === AppType.CHUB_APP) {
    const authCookie = cookiesObject[SESSION_COOKIE_CHUB_USER]

    return authCookie ? JSON.parse(authCookie).token || null : null
  }
  const authCookie = cookiesObject[SESSION_COOKIE_USER]
  return authCookie ? JSON.parse(authCookie).token || null : null
}

//-----------------Client------------------//
export function getAuthCookiesClient(cookies: Record<string, string>, appType: AppType) {
  if (appType === AppType.CHUB_APP) {
    return {
      sessionCookie: cookies[SESSION_COOKIE_NAME_CHUB],
      authCookie: cookies[SESSION_COOKIE_CHUB_USER],
      currentTenantCookie: cookies[SESSION_COOKIE_CHUB_CURRENT_TENANT],
      tenantsCookie: cookies[SESSION_COOKIE_TENANTS], // Shared
      errorMessage: cookies[SESSION_ERROR_MESSAGE]
    }
  }

  return {
    sessionCookie: cookies[SESSION_COOKIE_NAME],
    authCookie: cookies[SESSION_COOKIE_USER],
    currentTenantCookie: cookies[SESSION_COOKIE_CURRENT_TENANT],
    tenantsCookie: cookies[SESSION_COOKIE_TENANTS],
    errorMessage: cookies[SESSION_ERROR_MESSAGE]
  }
}

export function getAuthorizationBearerTokenClient(
  cookies: Record<string, string>,
  appType: AppType
): string | null {
  if (appType === AppType.CHUB_APP) {
    return cookies[SESSION_COOKIE_NAME_CHUB] || null
  }
  return cookies[SESSION_COOKIE_NAME] || null
}

export function getSignedTokenClient(
  cookies: Record<string, string>,
  appType: AppType
): string | null {
  if (appType === AppType.CHUB_APP) {
    return cookies[SESSION_COOKIE_CHUB_SIGNED_TOKEN] || null
  }
  return cookies[SESSION_COOKIE_SIGNED_TOKEN] || null
}
